import * as fabric from 'office-ui-fabric-react';
import React, { FC } from 'react';

interface IProps {
    onEditClick: Function;
    onDeleteClick: Function;
}

export const editButtonStyles: fabric.IButtonStyles = {
    root: {
        margin: '0px, 2px',
        color: fabric.getTheme().palette.themeDarker
    }
};
export const deleteButtonStyles: fabric.IButtonStyles = {
    root: {
        margin: '0px, 2px',
        color: fabric.getTheme().semanticColors.errorText
    }
};

const ListItemActionButtons: FC<IProps> = props => {
    return (
        <>
            <fabric.IconButton
                onClick={async () => await props.onEditClick()}
                iconProps={{
                    iconName: 'PageEdit'
                }}
                styles={editButtonStyles}
            />
            <fabric.IconButton
                onClick={async () => await props.onDeleteClick()}
                iconProps={{
                    iconName: 'Trash'
                }}
                styles={deleteButtonStyles}
            />
        </>
    );
};

export default ListItemActionButtons;
